(function () {
  'use strict';

  function initSvBogoBlock(block) {

    var options = {
      bogo: {
        boxes: 3,
        price: block.dataset.bogoPrice || '$80',
        anchor: block.dataset.bogoAnchor || '$120',
        perBar: block.dataset.bogoPerBar || '$2.22 / bar',
        label: block.dataset.bogoBilling || '3 boxes &middot; 36 bars total'
      },
      single: {
        boxes: 1,
        price: block.dataset.singlePrice || '$40',
        anchor: block.dataset.singleAnchor || '$49.99',
        perBar: block.dataset.singlePerBar || '$3.00 / bar',
        label: block.dataset.singleBilling || '1 box &middot; 12 bars'
      }
    };

    var selectedMode = 'bogo';
    var flavorQty = [0, 0, 0];
    var dialogWired = false;

    function qs(sel) { return block.querySelector(sel); }

    function findDialog() {
      var el = block.nextElementSibling;
      while (el) {
        if (el.tagName === 'DIALOG') return el;
        el = el.nextElementSibling;
      }
      return null;
    }

    var bogoCard   = qs('.sv-bogo-card--bogo');
    var singleCard = qs('.sv-bogo-card--single');
    var ctaBtn     = qs('.sv-bogo-cta-btn');
    var ctaText    = qs('.sv-bogo-cta-text');

    var RADIO_ON  = 'width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #000;background:#fff;margin-top:3px;flex-shrink:0;display:block;box-shadow:inset 0 0 0 4px #fff,inset 0 0 0 11px #434B92;';
    var RADIO_OFF = 'width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #ccc;background:#fff;margin-top:3px;flex-shrink:0;display:block;box-shadow:none;';

    function setRadio(card, on) {
      if (!card) return;
      var radio = card.querySelector('.sv-bogo-radio');
      if (radio) radio.setAttribute('style', on ? RADIO_ON : RADIO_OFF);
    }

    function updateCta() {
      if (!ctaText) return;
      var d = options[selectedMode];
      ctaText.innerHTML = 'Select Flavor' + (d.boxes > 1 ? 's' : '') + ' &mdash; <span class="sv-bogo-cta-was">' + d.anchor + '</span> ' + d.price + ' &rarr;';
    }

    function selectBogo() {
      selectedMode = 'bogo';
      if (bogoCard)   bogoCard.classList.add('active');
      if (singleCard) singleCard.classList.remove('active');
      setRadio(bogoCard, true);
      setRadio(singleCard, false);
      updateCta();
    }

    function selectSingle() {
      selectedMode = 'single';
      if (singleCard) singleCard.classList.add('active');
      if (bogoCard)   bogoCard.classList.remove('active');
      setRadio(singleCard, true);
      setRadio(bogoCard, false);
      updateCta();
    }

    if (bogoCard)   bogoCard.addEventListener('click', selectBogo);
    if (singleCard) singleCard.addEventListener('click', selectSingle);

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        openDialog();
      });
    }

    var backBtn, flavorInstEl, addBtns, qtyCtrls, qtyNums, flavorRows, confirmBtn, confirmText;

    function openDialog() {
      var dlg = findDialog();
      if (!dlg) return;

      flavorQty = [0, 0, 0];

      if (!dialogWired) {
        backBtn      = dlg.querySelector('.sv-bogo-back-btn');
        flavorInstEl = dlg.querySelector('.sv-bogo-flavor-inst');
        addBtns      = Array.prototype.slice.call(dlg.querySelectorAll('.sv-bogo-add-btn'));
        qtyCtrls     = Array.prototype.slice.call(dlg.querySelectorAll('.sv-bogo-qty-ctrl'));
        qtyNums      = Array.prototype.slice.call(dlg.querySelectorAll('.sv-bogo-qty-num'));
        flavorRows   = Array.prototype.slice.call(dlg.querySelectorAll('.sv-bogo-flavor-row'));
        confirmBtn   = dlg.querySelector('.sv-bogo-confirm-btn');
        confirmText  = dlg.querySelector('.sv-bogo-confirm-text');

        if (backBtn) backBtn.addEventListener('click', function () {
          dlg.close();
        });

        dlg.addEventListener('close', function () {
          document.body.style.overflow = '';
        });

        wireFlavorBtns();
        wireConfirmBtn();
        dialogWired = true;
      }

      resetFlavors();
      updateTally();
      dlg.showModal();
      document.body.style.overflow = 'hidden';
    }

    function wireFlavorBtns() {
      addBtns.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('disabled')) return;
          var total = flavorQty.reduce(function (a, b) { return a + b; }, 0);
          if (total >= options[selectedMode].boxes) return;
          flavorQty[idx]++;
          btn.style.display = 'none';
          if (qtyCtrls[idx]) qtyCtrls[idx].classList.add('show');
          if (qtyNums[idx])  qtyNums[idx].textContent = flavorQty[idx];
          if (flavorRows[idx]) flavorRows[idx].classList.add('has-qty');
          updateAddBtns();
          updateTally();
        });
      });

      var minusBtns = Array.prototype.slice.call(document.querySelectorAll('.sv-bogo-qty-btn--minus'));
      minusBtns.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          var next = flavorQty[idx] - 1;
          if (next < 0) return;
          flavorQty[idx] = next;
          if (qtyNums[idx]) qtyNums[idx].textContent = next;
          if (next === 0) {
            if (addBtns[idx])    addBtns[idx].style.display = '';
            if (qtyCtrls[idx])   qtyCtrls[idx].classList.remove('show');
            if (flavorRows[idx]) flavorRows[idx].classList.remove('has-qty');
          }
          updateAddBtns();
          updateTally();
        });
      });

      var plusBtns = Array.prototype.slice.call(document.querySelectorAll('.sv-bogo-qty-btn--plus'));
      plusBtns.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          var total = flavorQty.reduce(function (a, b) { return a + b; }, 0);
          if (total >= options[selectedMode].boxes) return;
          flavorQty[idx]++;
          if (qtyNums[idx]) qtyNums[idx].textContent = flavorQty[idx];
          updateAddBtns();
          updateTally();
        });
      });
    }

    function wireConfirmBtn() {
      if (!confirmBtn) return;
      confirmBtn.addEventListener('click', function () {
        if (confirmBtn.disabled) return;
        var variantIds = block.dataset.variantIds ? block.dataset.variantIds.split(',') : [];
        var items = [];

        flavorQty.forEach(function (qty, idx) {
          if (qty > 0 && variantIds[idx]) {
            items.push({
              id: parseInt(variantIds[idx].trim(), 10),
              quantity: qty
            });
          }
        });

        if (items.length === 0) return;

        confirmBtn.disabled = true;
        var spinner = confirmBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          confirmBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
          var dlg = findDialog();
          if (dlg) dlg.close();
          refreshCartDrawer();
        })
        .catch(function (err) {
          console.error('Supervibe BOGO add to cart error:', err);
          confirmBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
        });
      });
    }

    function resetFlavors() {
      flavorQty = [0, 0, 0];
      if (addBtns)    addBtns.forEach(function (btn) { btn.style.display = ''; btn.classList.remove('disabled'); });
      if (qtyCtrls)   qtyCtrls.forEach(function (c) { c.classList.remove('show'); });
      if (qtyNums)    qtyNums.forEach(function (el) { el.textContent = '0'; });
      if (flavorRows) flavorRows.forEach(function (row) { row.classList.remove('has-qty'); });
    }

    function updateAddBtns() {
      if (!addBtns) return;
      var total = flavorQty.reduce(function (a, b) { return a + b; }, 0);
      var full  = total >= options[selectedMode].boxes;
      addBtns.forEach(function (btn) {
        if (btn.style.display !== 'none') btn.classList.toggle('disabled', full);
      });
    }

    function updateTally() {
      var d         = options[selectedMode];
      var total     = flavorQty.reduce(function (a, b) { return a + b; }, 0);
      var remaining = d.boxes - total;

      if (confirmBtn && confirmText) {
        if (total === d.boxes) {
          confirmBtn.disabled     = false;
          confirmText.textContent = 'Add to Cart \u2014 ' + d.price + ' \u2192';
        } else {
          confirmBtn.disabled     = true;
          confirmText.textContent = 'Add ' + remaining + ' more box' + (remaining === 1 ? '' : 'es');
        }
      }
    }

    function refreshCartDrawer() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser     = new DOMParser();
          var doc        = parser.parseFromString(html, 'text/html');
          var cartDrawer = document.querySelector('cart-drawer');
          var newDrawer  = doc.querySelector('cart-drawer');
          if (cartDrawer && newDrawer) {
            cartDrawer.replaceWith(newDrawer);
            newDrawer.classList.add('active');
          }
        })
        .catch(function (err) { console.error('Cart drawer refresh error:', err); });
    }

    selectBogo();
  }

  function init() {
    document.querySelectorAll('.sv-bogo-block').forEach(initSvBogoBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.sv-bogo-block').forEach(initSvBogoBlock);
  });

}());
